export default String.raw`
{% assign whatPrice = translations.Brutto | Downcase -%}

{% if customer.Cart.SubtotalPrices -%}
    {% assign whatPrice = translations.Netto | Downcase -%}
{% endif -%}

{% assign view = 'quick-shopping' -%}

{% if settings.selectedViewName -%}
    {% assign view = settings.selectedViewName -%}
{% endif -%}

{% if page.Cookies.selectedViewName -%}
    {% assign view = page.Cookies.selectedViewName -%}
{% endif -%}

<div class="products-page products-page-js">
    {% include 'elements/categoryDescription/categoryDescription-1.html' -%}
    {% include 'elements/products-list/products-1.html' with 'products' -%}
</div>

<div class="during-ajax-modal-js during-ajax-modal hidden-js">
    <div class="loader big"></div>
</div>
`